/**
 * This is Common JS
 * Header(website-header) & Footer(window-section.-footer)
 */
import 'whatwg-fetch';

import '../css/normalize.css';
import '../css/contact/blur-cover.css';

/* eslint-disable */
const req = require.context('../css/common', true, /^(.*\.(css$))[^.]*$/igm);
req.keys().forEach((key)=>{req(key);});
/* eslint-enable */

(() => {
	/* eslint-disable */
	const scrollTo = (to, duration) => {
		if( duration <= 0 ) return;
		const difference = to - document.body.scrollTop;
		const perTick = difference / duration * 10;
		setTimeout( () => {
			document.body.scrollTop = document.body.scrollTop + perTick;
			if (document.body.scrollTop === to) return;
			scrollTo(to, duration - 10);
		}, 10);
	}
	/* eslint-enable */

	/**
	 * make Footer covered screen or not
	 * 		if .website-header is with .autocross
	 *		Move screen to two window height from the bottom
	 */
	document.querySelector('.navi-btn').addEventListener('click', (e) => {
		if (document.querySelector('.window-section.-footer').classList.contains('-covered')) {
			document.querySelector('.window-section.-footer').classList.remove('-covered');
			e.currentTarget.parentElement.classList.remove('-covered');
			document.body.classList.remove('_stop-scrolling');
		} else if (e.currentTarget.parentElement.classList.contains('-autocross')) {
			// scrollTo(document.querySelector('.-scrollTarget').offsetTop, 350);
			window.scrollTo({
				top: 0,
				left: 0,
				behavior: 'smooth',
			});
		} else {
			document.querySelector('.window-section.-footer').classList.add('-covered');
			document.querySelector('.window-section.-footer').style.top = '';
			e.currentTarget.parentElement.classList.add('-covered');
			document.body.classList.add('_stop-scrolling');
		}
	});
})();

/**
 * Export this function to let them call this by themselves
 * in `window.onload`
 */
export const windowOnLoad = () => {
	/**
	 * Banner image is loaded, hide the blur-cover
	 */
	if (document.querySelector('.blur-cover')) {
		const blurCover = document.querySelector('.blur-cover');

		if (!blurCover.classList.contains('-fadeOut')) {
			blurCover.className += ' -fadeOut';

			setTimeout(() => {
				document.body.removeChild(blurCover);
			}, 1000);
		}
	}

	const { innerWidth } = window;
	const isTablet = innerWidth > 720 && innerWidth <= 960;
	const isMobile = innerWidth > 0 && innerWidth <= 720;

	window.addEventListener('scroll', (e) => {
		const space4footer = document.querySelector('.window-section.-space4footer');
		const windowHeight = isTablet ? window.screen.height : window.innerHeight;
		const bodyHeight = document.body.offsetHeight;
		const space4footerHeight = space4footer.offsetHeight;

		// 兩個變數差在哪請讀 README
		const space4footerSectionPosition = document.querySelector('.window-section.-space4footer').offsetTop;
		const beforeSpace4footerPosition =
			document.querySelector('.window-section.-space4footer').previousElementSibling.offsetTop;
		// const footerPosition = bodyHeight - (isMobile ? windowHeight + space4footerHeight : windowHeight * 2);
		const autoCrossPositiont =
			bodyHeight - (isMobile ? (windowHeight * 0.3) + space4footerHeight : windowHeight * 1.3);
		const activedMenuPosition = (windowHeight * 3) / 4;

		/**
		 * As scroll over 3/4 window height
		 * lock Menu(header) position on the top-right screen
		 */
		if (e.currentTarget.pageYOffset >= activedMenuPosition) {
			document.querySelector('.website-header').classList.add('-fixed');
		} else {
			document.querySelector('.website-header').classList.remove('-fixed');
		}

		/**
		 * Change -footer position
		 * set absolute and move to top or bottom
		 */
		if (e.currentTarget.pageYOffset >= beforeSpace4footerPosition) {
			document.querySelector('.window-section.-footer').classList.add('-bottom');
			document.querySelector('.window-section.-footer').style.top = `${space4footerSectionPosition}px`;
		} else {
			document.querySelector('.window-section.-footer').classList.remove('-bottom');
			document.querySelector('.window-section.-footer').style.top = '';
		}

		/**
		 * User is close to the bottom.
		 * Add/Remove .website-header class (-autocross)
		 */
		if (e.currentTarget.pageYOffset >= autoCrossPositiont) {
			document.querySelector('.website-header').classList.add('-autocross');
		} else {
			document.querySelector('.website-header').classList.remove('-autocross');
		}
	});
};

/* eslint-disable */
/**
 * shuffle array
 * for slide-footer
 */
export const shuffleArr = (a) => {
	var j, x, i;
	for (i = a.length; i; i--) {
		j = Math.floor(Math.random() * i);
		x = a[i - 1];
		a[i - 1] = a[j];
		a[j] = x;
	}
	return a;
}
/* eslint-enable */

/**
 * 取得最新年份並使用在 footer 上的 .copyright
 */
const innerText = `COPYRIGHTⓒ ${new Date().getFullYear()} 25sprout,LLC. All RIGHTS RESERVED`;

document.querySelector('.footer-content.-left> .copyright').textContent = innerText;



// WEBPACK FOOTER //
// ./src/js/common.js